export const STATUS_STYLES = {
  placed: "bg-amber-100 text-amber-800 border-amber-200",
  processing: "bg-sky-100 text-sky-800 border-sky-200",
  dispatched: "bg-pink-100 text-pink-800 border-pink-200",
  delivered: "bg-emerald-100 text-emerald-800 border-emerald-200",
  cancelled: "bg-red-100 text-red-800 border-red-200",
};

export const ORDER_STATUSES = ["placed", "processing", "dispatched", "delivered", "cancelled"];

const LABEL = { delivered: "Delivered to Metcash" };

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${cls}`}
    >
      {LABEL[status] || String(status || "").replace(/_/g, " ")}
    </span>
  );
}

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n || 0);

function _toDate(d) {
  if (!d) return null;
  if (d instanceof Date) return isNaN(d) ? null : d;
  const s = String(d);
  const dt = new Date(s.length <= 10 ? `${s}T00:00:00` : s);
  return isNaN(dt) ? null : dt;
}

// Australian date format: DD/MM/YYYY
export function fmtDate(d) {
  const dt = _toDate(d);
  if (!dt) return d ? String(d) : "";
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${dt.getFullYear()}`;
}

// e.g. "Thu 01/10/2026"
export function fmtDateDow(d) {
  const dt = _toDate(d);
  if (!dt) return d ? String(d) : "";
  const dow = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dt.getDay()];
  return `${dow} ${fmtDate(dt)}`;
}

// e.g. "01/10/2026 14:30"
export function fmtDateTime(d) {
  const dt = _toDate(d);
  if (!dt) return "—";
  return `${fmtDate(dt)} ${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
}
